export const runbookExecutionHistoryLineConstants = {
  GET_REQUEST: "GET_RUNBOOK_EXECUTION_HISTORY_LINE_REQUEST",
  GET_SUCCESS: "GET_RUNBOOK_EXECUTION_HISTORY_LINE_SUCCESS",
  GET_FAILURE: "GET_RUNBOOK_EXECUTION_HISTORY_LINE_FAILURE",
};
